<template>

    <div class="joker">

        <market v-if="card.type === ENUM.NEWSLETTERS.CARDS.MARKET"
                :card="card"></market>

        <sharing v-if="card.type === ENUM.NEWSLETTERS.CARDS.SHARING"
                 @share="$emit('share')"></sharing>

        <happy-foxy-card v-if="card.type === ENUM.NEWSLETTERS.CARDS.ANIMATION" :text="foxyCardText"></happy-foxy-card>

        <subscriptions v-if="showCardSubscriptions" :subscription="card"></subscriptions>

    </div>

</template>

<script>

import ENUM from '../../../assets/ENUM'

import HappyFoxyCard from '../../../components/newsletters-v2/cardsTemplate/HappyFoxyCard'
import Market from '../../../components/newsletters-v2/cardsTemplate/Market'
import Sharing from '../../../components/newsletters-v2/cardsTemplate/Sharing'
import Subscriptions from '../../../components/newsletters-v2/cardsTemplate/Subscriptions'

export default {

    name: 'joker',

    components: {
        HappyFoxyCard,
        Market,
        Sharing,
        Subscriptions
    },

    props: {
        card: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },

    computed: {
        ENUM() {
            return ENUM
        },

        showCardSubscriptions() {
            switch (this.card.type) {
                case ENUM.NEWSLETTERS.CARDS.MARKET:
                case ENUM.NEWSLETTERS.CARDS.SHARING:
                case ENUM.NEWSLETTERS.CARDS.ANIMATION:
                    return false
                default:
                    return true
            }
        },

        foxyCardText() {
            return this.card.name === ENUM.NEWSLETTERS.SPECIALS.USED_FOXY_CARD_ANIMATION + 'A' ? this.$t('animation_cards_foxy_25') : this.$t('animation_cards_foxy_50')
        }
    }
}

</script>

<style lang="scss" scoped>

.joker {
    width: 100%;
    display: flex;
    flex-grow: 1;
    border-radius: 72px;
}

</style>
